import {Component, OnInit, AfterViewInit, Input, Renderer2, Output, EventEmitter, OnDestroy} from '@angular/core';
import {DataService} from '../../../_services/data.service';
import {Item} from '../../../_core/_interface/item';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../_services/auth.service';
import {User} from '../../../_core/_interface/user';
import {threadId} from 'worker_threads';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {Location} from '@angular/common';
import {prototype} from 'events';
import {BuildingFlat} from "../../../_core/_interface/buildingFlat";
import {Subscription} from "rxjs";
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';

@Component({
    selector: 'app-flat-test',
    templateUrl: './flat-test.component.html',
    styleUrls: ['./flat-test.component.scss'],
})
export class FlatTestComponent implements OnInit, AfterViewInit, OnDestroy {
    items: Item[];
    user: User;
    public compId;
    itemToEdit: Item;
    proto: any;
    selectedFlat;
    additionalProperties: boolean = false;
    compositeDesign: boolean = false;
    unika: boolean = false;
    currentFlatId: string;
    hideRoomNumberProperty: boolean = true;

    @Input() buildUid: string;
    @Input() flats: any;
    @Input() flat: BuildingFlat;
    @Input() build;
    @Output() public showFloorPlanEmit = new EventEmitter();
    desktopResolution: boolean = true;
    iframeElement: any;
    buildingName: string;
    editState: boolean = false;
    collection = 'buildings/';
    flatstatuss: string[] = ['free', 'waiting', 'sold'];
    sehelUser: string = '';
    postData: any = {};
    likes: any[] = [];
    highlightLike: any[];
    sehelProjId: string = '';
    projUid: string = '';
    showFloorPlan: boolean = false;
    itemToShow: string = '';
    wholeNum: boolean = false;
    ifThree: boolean = false;
    buildType: string = "";
    currentUnitNumber: string = '';
    currentLanguage: string = 'he';
    simpleGallery: boolean = false;
    markerUnitNumberSubscriber: Subscription

    constructor(private dataService: DataService,
                private route: ActivatedRoute,
                private router: Router,
                private auth: AuthService,
                private http: HttpClient,
                private location: Location,
                private renderer: Renderer2) {
        this.compId = route.snapshot.paramMap.get('id');
        // this.projUid = this.compId = route.snapshot.paramMap.get('idp');
        this.projUid = route.snapshot.paramMap.get('idp');
        this.sehelUser = this.route.snapshot.params.seheluser;
        this.postData.clientId = this.route.snapshot.params.seheluser;
    }


    ngOnInit() {
        if (this.route.snapshot.queryParams.lang) {
            this.currentLanguage = this.route.snapshot.queryParams.lang;
        }
        this.buildType = this.build.buildType;
        let likesList = JSON.parse(localStorage.getItem('likesList'));
        if (likesList) {
            this.highlightLike = likesList.highlightLike;
        }
        this.compositeDesign = this.dataService.wichDesign().compositeDesign;
        this.unika = this.dataService.wichDesign().unika;
        if (window.innerWidth < 1200) {
            this.desktopResolution = false;
        }
        let appthreejs = document.getElementsByTagName('app-threejs')[0];

        if (appthreejs?.getElementsByTagName('canvas').length > 0) {
            this.ifThree = true;
        }

        if (this.build.hideRoomNumberProperty !== undefined && this.build.hideRoomNumberProperty === false) {
            this.hideRoomNumberProperty = false;
        } else {
            this.hideRoomNumberProperty = true;
        }
        this.buildingName = JSON.parse(localStorage.getItem('buildingName'));
        this.user = this.auth.currentUserValue;

        this.items = this.flats;
        this.markerUnitNumberSubscriber = this.dataService.markerUnitNumberSVG.subscribe(unitNumber => {
            this.currentUnitNumber = unitNumber;
        })
        if (!this.unika && !this.compositeDesign) {
            this.additionalProperties = true;
        }
        if (this.route.snapshot.paramMap.get('flatId')) {
            if (this.flat.id === this.route.snapshot.paramMap.get('flatId')) {
                this.showFlatProperties(event, this.flat);
            }
        }
        if (this.sehelUser) {
            this.sehelProjId = sessionStorage.getItem('sehelProjId');
        }

        this.wholeNum = JSON.parse(localStorage.getItem('wholeNum'));
    }

    isNoItemsF($event, item, wichGallery) {
        console.log("Delayed for 1 second.");

        if (wichGallery === 'simpleGallery' && !this.simpleGallery) {
            this.simpleGallery = !$event;
        }
    }

    onRadioChange(event) {
        console.log('Selected:', event.value);
    }

    hightlightFloorPlan(item, action) {
        if (this.buildType !== 'SVG' && this.buildType !== 'office' && this.buildType !== 'housing') {
            return;
        }
        let className = '.name-' + item.number;
        let element = document.querySelector(className);
        if (element && action === 'add') {
            element.classList.add('highlightUnit');
        } else if (element) {
            element.classList.remove('highlightUnit');
        }
    }

    showFloorPlanF(e, curFlatToEdit) {
        this.showFloorPlanEmit.emit(this.flat.floorId);
        e.preventDefault();
        e.stopPropagation();
    }

    closeFloorDrawing(e) {
        this.showFloorPlan = false;
        let element = document.getElementsByClassName('composite-design')[0];
        element.classList.remove('opened-floor-drawing');
        e.preventDefault();
        e.stopPropagation();
    }

    prevent(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    ifLike(item) {
        if (this.highlightLike) {
            return this.highlightLike.includes(item.id);
        }
    }

    likeUnlike(event, item) {
        event.stopPropagation();
        event.preventDefault();
        this.likes = [];
        let likesList: any = {};
        this.highlightLike = [];
        likesList = JSON.parse(localStorage.getItem('likesList'));
        if (likesList && likesList.uiserId === this.sehelUser) {
            this.likes = likesList.likes;
            this.highlightLike = likesList.highlightLike;
        }
        let urlAppartmens = 'https://crm.sehel.co.il/api/3d/getAppartment/' + this.sehelProjId + '/' + this.buildingName + '/0/' + item.number;
        let postData = JSON.stringify({"token": "spirikal-427c-4921-927b-795020264f93"});
        this.http.post(urlAppartmens, postData).toPromise().then(data => {
            let appartment: any = data;
            this.postData.action = 'APP_LIKE';
            this.postData.apartmentId = appartment.data.id;
            if (!this.likes.includes(this.postData.apartmentId)) {
                this.likes.push(appartment.data.id);
                this.highlightLike.push(item.id);
            } else {
                let indexHightlightLike = this.highlightLike.indexOf(item.id);
                this.highlightLike.splice(indexHightlightLike, 1);
                let index = this.likes.indexOf(this.postData.apartmentId);
                this.likes.splice(index, 1);

                this.postData.action = 'APP_UNLIKE';
            }
            this.dataService.postSehel('setAction', this.postData);
            localStorage.setItem('likesList', JSON.stringify({
                uiserId: this.sehelUser,
                likes: this.likes,
                highlightLike: this.highlightLike
            }));
        });
    }

    ngAfterViewInit(): void {
        // AfterViewInit is the right lifecycle hook to manipulate DOM elements

    }

    showHotspot(flat) {
        this.dataService.markerFlatOnHover(flat);
        if (flat.hotspotName) {
            // this.closeViewFloors();

            const data = {
                hotspotName: flat.hotspotName,
                flatName: this.buildingName + "_" + flat.number,
                flatStatus: flat.status,
                flatFloor: flat.floorNumber,
                singleFlat: 'false  '
            };


            // const data = hotspotName;
            // Set url to be sure that the message will be sent to only this url
            // Full url to iframe

            postMessageToIframe(data);

            // const url = 'https://topeye.club/';
            // //  Access iframe by name
            // // const win = window.frames.tourIframe;
            // const test = document.getElementsByClassName("da-iframe");
            // let test1: HTMLIFrameElement;
            // if (test.length > 0) {
            //     test1 = test[0].getElementsByTagName('iframe')[0];
            // }
            // const win = test1;

            // if (win) {
            //     this.iframeElement = eval("(win.contentWindow || win.contentDocument)");
            //     this.iframeElement.postMessage(JSON.stringify(data), url);
            // }
        }
    }


    additionalPropertiesF($event, item) {
        // if (window.innerWidth < 1200) {
        if (this.compositeDesign && !this.additionalProperties && !this.desktopResolution) {
            $event.stopPropagation();
            $event.preventDefault();
            this.currentFlatId = item.id;
            this.additionalProperties = true;
        } else if (this.additionalProperties) {
            this.showFlatProperties($event, item);
        }
    }

    goToHotspotAnotherScene() {
        const flat = {
            hotspotName: 'spotpoint37004',
            number: 'TEST',
            scene: 'pano22650'
        }
        if (flat.hotspotName) {
            // this.closeViewFloors();

            const data = {
                hotspotName: flat.hotspotName,
                flatName: flat.number,
                scene: flat.scene,
                singleFlat: 'false'
            };


            // const data = hotspotName;
            // Set url to be sure that the message will be sent to only this url
            // Full url to iframe

            postMessageToIframe(data);

            // const url = 'https://topeye.club/';
            // //  Access iframe by name
            // // const win = window.frames.tourIframe;
            // const test = document.getElementsByClassName("da-iframe");
            // let test1: HTMLIFrameElement;
            // if (test.length > 0) {
            //     test1 = test[0].getElementsByTagName('iframe')[0];
            // }
            // const win = test1;

            // if (win) {
            //     this.iframeElement = eval("(win.contentWindow || win.contentDocument)");
            //     this.iframeElement.postMessage(JSON.stringify(data), url);
            // }
        }
    }

    showFlatProperties($event, flat) {
        this.dataService.markerFlatOnClick(flat);
        if (this.showFloorPlan || flat.status === 'sold' || flat.status === 'notForSale' || this.ifThree) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (flat.faltPrototype !== undefined) {
            this.dataService.flatProperties(flat);
            // if (this.compositeDesign && !this.unika) {
            //     const url = '/company/n/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + flat.id;
            //     if (window.innerWidth < 1200) {
            //         this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + flat.id]);
            //     } else {
            //         this.location.go(url);
            //     }
            // } else
            if (this.unika) {
                let seheluser = this.route.snapshot.paramMap.get("seheluser");
                let sehelusersector = '';
                if (seheluser) {
                    sehelusersector = '/seheluser/' + seheluser;
                }
                const url = '/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + sehelusersector + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + flat.id;
                if (window.innerWidth < 1200) {
                    this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + sehelusersector + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + flat.id], {
                        queryParams: {lang: this.currentLanguage},
                        queryParamsHandling: 'merge' // Merges with any existing query params in the URL
                    });
                } else {
                    // this.location.go(url);
                    this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + sehelusersector + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + flat.id], {
                        queryParams: {lang: this.currentLanguage},
                        queryParamsHandling: 'merge' // Merges with any existing query params in the URL
                    });
                }
            } else {
                this.router.navigate(['/company/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + flat.id]);
                const removeSelection = document.getElementsByClassName('selected');
                if (removeSelection.length > 0) {
                    removeSelection[0].classList.remove('selected');
                }
                const addSelection = $event.target.parentNode.parentNode;
                addSelection.className += ' selected';
                this.selectedFlat = '';
                this.selectedFlat = flat;
            }
        } else {
            this.dataService.flatProperties(flat);
                if (this.unika) {
                let seheluser = this.route.snapshot.paramMap.get("seheluser");
                let sehelusersector = '';
                if (seheluser) {
                    sehelusersector = '/seheluser/' + seheluser;
                }
                const url = '/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + sehelusersector + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + flat.id;
                if (window.innerWidth < 1200) {
                    this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + sehelusersector + '/building/' + this.route.snapshot.paramMap.get("buid") + '/' + flat.id]);
                } else {
                    this.location.go(url);
                }
            }
        }
    }

    editItem(event, item) {
        this.editState = !this.editState;
        this.itemToEdit = item;
        event.stopPropagation();
        event.preventDefault();
    }

    updateItem(item) {
        this.dataService.updateItem(this.build, this.collection);
        this.clearState();
    }

    clearState() {
        this.editState = false;
        this.itemToEdit = null;
    }

    closeEdit() {
        this.editState = false;
    }
    ngOnDestroy() {
        this.markerUnitNumberSubscriber && this.markerUnitNumberSubscriber.unsubscribe();
    }
}

